import { getRequest, postRequest, putRequest, deleteRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getReasons = async (value) => {
  try {
    return await getRequest(urls.REASONS + `?category=${value}`);
  } catch (err) {
    return err;
  }
};

export const updateHardware = async (payload, id) => {
  try {
    return await putRequest(urls.UPDATE_HARDWARE + `/${id}`, payload);
  } catch (err) {
    return err;
  }
};

export const getMaterialMappings = async (payload) => {
  try {
    return await postRequest(urls.MATERIAL_MAPPING, payload);
  } catch (err) {
    return err;
  }
};
export const uploadImage = async (vehicleId, bundleId, file) => {
  const url = `${urls.UPLOAD_IMAGE}/${vehicleId}/${bundleId}`;

  // Create FormData for the file

  const formData = new FormData();
  formData.append("file", file); // 'file' is the expected field name by your API
  formData.append("vehicleId", vehicleId);
  formData.append("bundleId", bundleId);

  return await postRequest(url, formData);
};

export const deleteFileFromBundle = async (vehicleId, bundleId, fileName) => {
  const url = `${urls.DELETE_IMAGE}/${vehicleId}/${bundleId}/${fileName}`;
  return deleteRequest(url); // Using the generic deleteRequest
};

/**
 * Retrieves a list of files (or file metadata) for a specific vehicle and bundle.
 * @param {string} vehicleId - The ID of the vehicle.
 * @param {string} bundleId - The ID of the bundle.
 * @returns {Promise<AxiosResponse>} A promise that resolves with the Axios response containing file data.
 */
export const retrieveBundleFiles = async (vehicleId, bundleId) => {
  const url = `${urls.RETRIVE_IMAGE}/${vehicleId}/${bundleId}`;
  return getRequest(url); // Using the generic getRequest
};

export const getExistingHardwareRequest = async (vehicleId) => {
  try {
    return await getRequest(urls.HARDWARE_REQUEST + `?pagenum=0&pagesize=1&vehicleid=${vehicleId}`);
  } catch (err) {
    return err;
  }
};

export const createHardwareRequest = async (payload) => {
  try {
    return await postRequest(urls.HARDWARE_REQUEST, payload);
  } catch (err) {
    return err;
  }
};

// Used for: Cancel request, Accept hardware Request and Use Current Recommendaions
export const updateHardwareRequest = async (payload, id) => {
  try {
    return await putRequest(urls.HARDWARE_REQUEST + `/${id}`, payload);
  } catch (err) {
    return err;
  }
};

export const changeVehicle = async (payload) => {
  try {
    return await postRequest(urls.CHANGE_VEHICLE, payload);
  } catch (err) {
    if (err.response && err.response.status === 409) {
      return err.response;
    }
    return err;
  }
};
